export class MealModel {

    public Name: string;
    public RestroId: number;
    public Price: number;
    public MealCategoryId: number;
    public IsRecommend: boolean;
    public IsCustomDish: boolean;
    public ImageUrl: string;
    public IsFeatured: boolean;
    public MealMainId: number;
    public Description: string;
    public Quantity: number;
    public Discount: string;
    public Rating: number;
    public TimeDuration: string;
    public Tags: string;
    public ingredients: [
      {
        Ingredient: {
          Name: string;
          MealId: number;
        },

        ingeredientType: [
          {
            Name: string;
            MainIngredientsId: number;
          }

        ]
      }
    ];
    public Scales: [
      {
        Scale: {
          Name: string;
          MealId: number;
          IsDefault: boolean;
        },
        Unit: [
          {
            Name: string;
            ScaleId: number;

          }
        ]
      }
    ];
    public addons: [
      {


        Name: string;
        Price: number

      }

    ];



  }